<style lang='less' scoped>
.org-analysis {
  width: 100%;
  padding: 20px;
  .org-up {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      width: 100%;
      height: 600px;
      background: #fff;
      border-radius: 20px;
    }
  }
  .org-down {
    width: 100%;
    margin-top: 40px;
    .homework-avg {
      width: 100%;
      height: 600px;
      background: #fff;
      border-radius: 20px;
    }
    .homework-ratio {
      width: 100%;
      height: 600px;
      background: #fff;
      border-radius: 20px;
    }
  }
  .title {
    font-size: 24px;
    color: #000;
    font-weight: bold;
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
  .condition {
    width: 100%;
    display: flex;
    align-items: center;
    height: 80px;
  }
  .content {
    width: 100%;
  }
}
</style>
<template>
  <section class="org-analysis">
    <div class="org-up">
      <div class="homework-count">
        <div class="title">作业完成数量</div>
        <div class="condition">
          <DatePicker
            type="daterange"
            :value="startCountDate"
            format="yyyy/MM/dd"
            placement="bottom-start"
            :options="shortcutsOption"
            style="width: 200px;margin-left:132px;"
            @on-change="SetNewCountDate"
          />
          <Cascader
            style="margin-left:12px;"
            :data="groupList"
            v-model="countGroupAndClass"
            @on-change="CountGroupChange"
          />
        </div>
        <div class="content">
          <cisBar
            :x-list="xCountList"
            :series-name="seriseCountName"
            :series-data="seriseCountList"
          />
        </div>
      </div>
    </div>
    <div class="org-down">
      <div class="homework-ratio">
        <div class="title">作业完成率</div>
        <div class="condition">
          <DatePicker
            type="daterange"
            :value="startRatioDate"
            placement="bottom-start"
            :options="shortcutsOption"
            style="width: 200px;margin-left:132px;"
            @on-change="SetNewRatioDate"
          />
          <Cascader
            style="margin-left:12px;"
            :data="groupList"
            v-model="ratioGroupAndClass"
            @on-change="RatioGroupChange"
          />
        </div>
        <div class="content">
          <cisLine
            :x-list="xRatioList"
            :series-name="seriseRatioName"
            :series-data="seriseRatioList"
          />
        </div>
      </div>
    </div>
    <div class="org-down">
      <div class="homework-avg">
        <div class="title">作业成绩趋势</div>
        <div class="condition">
          <DatePicker
            type="daterange"
            :value="startAvgDate"
            placement="bottom-start"
            :options="shortcutsOption"
            style="width: 200px;margin-left:132px;"
            @on-change="SetNewAvgDate"
          />
          <Cascader
            style="margin-left:12px;"
            :data="groupList"
            v-model="avgGroupAndClass"
            @on-change="AvgGroupChange"
          />
        </div>
        <div class="content">
          <cisLine
            :x-list="xAvgList"
            :series-name="seriseAvgName"
            :series-data="seriseAvgList"
            :isSmooth="true"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import analysisApi from '@lib/api/analysis'
const DAT_MINI_SECOND = 3600 * 1000 * 24
export default {
  name: 'OrgAnalysis',
  data() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
    return {
      groupCountId: '',
      startCountTime: '',
      endCountTime: '',
      institutionCountId: '',
      xCountList: [], // '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月'
      seriseCountName: [], // '指标1', '指标2', '指标3', '指标4', '指标5', '指标6', '指标7', '指标8'
      seriseCountList: [], // 单个系列 [111,222,333]
      groupRatioId: '',
      startRatioTime: '',
      endRatioTime: '',
      institutionRatioId: '',
      xRatioList: [], // '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月'
      seriseRatioName: [], // '指标1', '指标2', '指标3', '指标4', '指标5', '指标6', '指标7', '指标8'
      seriseRatioList: [], // 单个系列 [111,222,333]
      groupAvgId: '',
      startAvgTime: '',
      endAvgTime: '',
      institutionAvgId: '',
      xAvgList: [], // '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月'
      seriseAvgName: [], // '指标1', '指标2', '指标3', '指标4', '指标5', '指标6', '指标7', '指标8'
      seriseAvgList: [], // 单个系列 [111,222,333]
      groupList: [],
      startCountDate: [start, end],
      setCountDate: [start, end],
      startRatioDate: [start, end],
      setRatioDate: [start, end],
      startAvgDate: [start, end],
      setAvgDate: [start, end],
      shortcutsOption: {
        shortcuts: [
          // {
          //   text: '今天',
          //   value () {
          //     const end = new Date()
          //     const start = new Date()
          //     return [start, end]
          //   }
          // },
          {
            text: '昨天',
            value() {
              const start = new Date()
              const end = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND)
              end.setTime(end.getTime() - DAT_MINI_SECOND)
              return [start, end]
            }
          },
          {
            text: '过去7天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 7)
              return [start, end]
            }
          },
          {
            text: '过去30天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 30)
              return [start, end]
            }
          },
          {
            text: '过去60天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 60)
              return [start, end]
            }
          },
          {
            text: '过去90天',
            value() {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - DAT_MINI_SECOND * 90)
              return [start, end]
            }
          }
        ]
      },
      countGroupAndClass: [],
      ratioGroupAndClass: [],
      avgGroupAndClass: []
    }
  },
  mounted() {
    this.GetGroupData()
  },
  methods: {
    GetGroupData() {
      analysisApi.GetGroupAndClass().then(result => {
        const data = result.data
        this.groupList = [
          {
            value: 0,
            label: '全部',
            children: [
              {
                value: 0,
                label: '全部'
              }
            ]
          },
          ...data.map(item => {
            return {
              value: item.institution_id,
              label: item.name,
              children: [
                {
                  value: 0,
                  label: '全部'
                },
                ...item.groups.map(sItem => {
                  return {
                    value: sItem.id,
                    label: sItem.name
                  }
                })
              ]
            }
          })
        ]
        this.GetHomeworkCount()
        this.GetHomeworkRatio()
        this.GetHomeworkAvg()
      })
    },
    GetHomeworkCount() {
      analysisApi
        .GetHomeworkCountData({
          groupId: this.groupCountId,
          startTime: new Date(this.setCountDate[0]).format('yyyy-MM-dd'),
          endTime: new Date(this.setCountDate[1]).format('yyyy-MM-dd'),
          institutionId: this.institutionCountId
        })
        .then(result => {
          const data = result.data
          this.xCountList = data.xList
          this.seriseCountName = data.series
          this.seriseCountList = data.seriesData.map(item => item.data)
          console.log(
            this.seriseCountList,
            this.seriseCountName,
            this.xCountList
          )
        })
    },
    GetHomeworkRatio() {
      analysisApi
        .GetHomeworkRatioData({
          groupId: this.groupRatioId,
          startTime: new Date(this.setRatioDate[0]).format('yyyy-MM-dd'),
          endTime: new Date(this.setRatioDate[1]).format('yyyy-MM-dd'),
          institutionId: this.institutionRatioId
        })
        .then(result => {
          const data = result.data
          this.xRatioList = data.xList
          this.seriseRatioName = data.series
          this.seriseRatioList = data.seriesData.map(item => item.data)
        })
    },
    GetHomeworkAvg() {
      analysisApi
        .GetHomeworkAvgData({
          groupId: this.groupAvgId,
          startTime: new Date(this.setAvgDate[0]).format('yyyy-MM-dd'),
          endTime: new Date(this.setAvgDate[1]).format('yyyy-MM-dd'),
          institutionId: this.institutionAvgId
        })
        .then(result => {
          const data = result.data
          this.xAvgList = data.xList
          this.seriseAvgName = data.series
          this.seriseAvgList = data.seriesData.map(item => item.data)
        })
    },
    SetNewCountDate(formatDate) {
      this.setCountDate = formatDate
      this.GetHomeworkCount()
    },
    SetNewRatioDate(formatDate) {
      this.setRatioDate = formatDate
      this.GetHomeworkRatio()
    },
    SetNewAvgDate(formatDate) {
      this.setAvgDate = formatDate
      this.GetHomeworkAvg()
    },
    CountGroupChange(value) {
      this.institutionCountId = value[0]
      this.groupCountId = value[1]
      this.GetHomeworkCount()
    },
    RatioGroupChange(value) {
      this.institutionRatioId = value[0]
      this.groupRatioId = value[1]
      this.GetHomeworkRatio()
    },
    AvgGroupChange(value) {
      this.institutionAvgId = value[0]
      this.groupAvgId = value[1]
      this.GetHomeworkAvg()
    }
  }
}
</script>
